import { MembershipRole } from '@/types/api/membership';
import { OnboardingStep } from '@/types/shared/onboarding/onboarding-step';
import { OnboardingType } from '@/types/shared/onboarding/enums/onboarding-type.enum';
import { OnboardingFailureCode } from '@/types/shared/onboarding';

type OnboardingConfig = {
  failureMessages: { [key in OnboardingFailureCode]: string };
  types: {
    [key in OnboardingType]: {
      successMessage: string;
      steps: OnboardingStep<key>[];
    };
  };
};

const onboardingConfig: OnboardingConfig = {
  failureMessages: {
    [OnboardingFailureCode.Unknown]: 'Något gick fel, försök igen senare.',
    [OnboardingFailureCode.NoToken]: 'Länken är ogiltig. Be den som delade länken med dig om en ny.',
    [OnboardingFailureCode.InvalidToken]: 'Länken är ogiltig. Be den som delade länken med dig om en ny.',
    [OnboardingFailureCode.ExpiredToken]: 'Inbjudningslänken har gått ut. Be den som delade länken med dig om en ny.',
    [OnboardingFailureCode.MissingDataProperties]: 'Länken är ogiltig. Be den som delade länken med dig om en ny.',
  },

  types: {
    [OnboardingType.Membership]: {
      successMessage: 'Sådär, nu är det bara att köra hårt! 🙌',
      steps: [
        {
          index: 1,
          path: 'email',
          progressbar: { label: 'Användaruppgifter', hide: true },
        },
        {
          index: 2,
          path: 'user',
          skip: (data) => Boolean(data.userExists),
          progressbar: { label: 'Användaruppgifter', indexOverride: 1 },
        },
        {
          index: 3,
          path: 'otp',
          progressbar: { label: 'Verifiera e-post', indexOverride: 2 },
        },
        {
          index: 4,
          path: 'bankid',
          skip: (data) => data.role !== MembershipRole.Leader,
          progressbar: { label: 'BankID', hide: true, indexOverride: 3 },
        },
        {
          index: 5,
          path: 'confirm',
          progressbar: { label: 'Gå med i grupp', indexOverride: 3 },
        },
      ],
    },

    [OnboardingType.Group]: {
      successMessage: 'Grattis! Du har skapat en Piggogrupp 🙌',
      steps: [
        {
          index: 1,
          path: 'email',
          progressbar: { label: 'Användaruppgifter', hide: true },
        },
        {
          index: 2,
          path: 'user',
          skip: (data) => Boolean(data.userExists),
          progressbar: { label: 'Användaruppgifter', indexOverride: 1 },
        },
        {
          index: 3,
          path: 'otp',
          progressbar: { label: 'Verifiera e-post', indexOverride: 2 },
        },
        {
          index: 4,
          path: 'bankid',
          progressbar: { label: 'BankID', indexOverride: 3 },
        },
        {
          index: 5,
          path: 'confirm',
          progressbar: { label: 'Gruppuppgifter', indexOverride: 4 },
        },
      ],
    },

    [OnboardingType.Sale]: {
      successMessage: 'Sådär, nu är det bara att köra hårt! 🙌',
      steps: [
        /* {
          index: 1,
          path: 'address',
          progressbar: { label: 'Faktureringsadress' },
        }, */
        {
          index: 1,
          path: 'payout',
          progressbar: { label: 'Utbetalning' },
        },
        {
          index: 2,
          path: 'confirm',
          progressbar: { label: 'Försäljningsuppgifter' },
        },
      ],
    },
  },
};

export default onboardingConfig;
